import SosHome from "../app/web/sos/sos-home/sos-home.jsx";
import CitizensList from "../app/web/sos/citizen/list/citizens-list.jsx";
import CitizenIndex from "../app/web/sos/citizen/form/citizen-index.jsx";
import CitizenHistory from "../app/web/sos/citizen-history/citizen-history.jsx";
import SosOpenList from "../app/web/sos/events/list/open/sos-open-list.jsx";
import SosHistoryList from "../app/web/sos/events/list/history/sos-history-list.jsx";
import SosView from "../app/web/sos/events/view/sos-view.jsx";
import AggressorsList from "../app/web/sos/aggressors-list/aggressors-list.jsx";
import ProtectionProgramList from "../app/web/sos/protection-program/list/protection-program-list.jsx";
import ProtectionProgramForm from "../app/web/sos/protection-program/form/protection-program-form.jsx";
import CitizenScheduledVisitList from "../app/web/sos/citizen-scheduled-visit/list/citizen-scheduled-visit-list.jsx";
import CitizenScheduledVisitForm from "../app/web/sos/citizen-scheduled-visit/form/citizen-scheduled-visit-form.jsx";
import {requirePermission} from "./middleware.js";
import {PermissionEnum} from "../utils/enums/permission-enum.js";
import DashboardSos from "../app/web/sos/dashboard-sos/dashboard-sos.jsx";

const CITIZEN = [PermissionEnum.SOS_MANAGE_CITIZEN, PermissionEnum.SOS_MANAGE_EVENTS, PermissionEnum.SOS_VIEW];

const RouterSos = () => [
    {
        id: "sos-home",
        path: "home",
        Component: SosHome,
        loader: requirePermission("sentry.sos.*")
    },

    {
        id: "citizens",
        path: "citizens",
        Component: CitizensList,
        loader: requirePermission(CITIZEN)
    },
    {
        id: "citizen-form",
        path: "citizens/form/:id?",
        Component: CitizenIndex,
        loader: requirePermission(CITIZEN)
    },
    {
        id: "citizen-history",
        path: "citizen/history/:id",
        Component: CitizenHistory,
        loader: requirePermission(CITIZEN)
    },

    {
        id: "sos-open",
        path: "event-open",
        Component: SosOpenList,
        loader: requirePermission(PermissionEnum.SOS_MANAGE_EVENTS)
    },
    {
        id: "sos-history",
        path: "event-history",
        Component: SosHistoryList,
        loader: requirePermission(PermissionEnum.SOS_MANAGE_EVENTS)
    },
    {
        id: "sos-history-view",
        path: "event-history/:id",
        Component: SosView,
        loader: requirePermission(PermissionEnum.SOS_MANAGE_EVENTS)
    },
    {
        id: "sos-event-open",
        path: "event-open/:id",
        Component: SosView,
        loader: requirePermission(PermissionEnum.SOS_MANAGE_EVENTS)
    },
    {
        id: "aggressors-list",
        path: "aggressors-list",
        Component: AggressorsList,
        loader: requirePermission(CITIZEN)
    },

    {
        id: "protection-program",
        path: "protection-program",
        Component: ProtectionProgramList,
        loader: requirePermission(PermissionEnum.SOS_PROTECTION_PROGRAM)
    },
    {
        id: "protection-program-form",
        path: "protection-program/form/:id?",
        Component: ProtectionProgramForm,
        loader: requirePermission(PermissionEnum.SOS_PROTECTION_PROGRAM)
    },

    {
        id: "citizen-scheduled-visit",
        path: "citizen-scheduled-visit",
        Component: CitizenScheduledVisitList,
        loader: requirePermission(PermissionEnum.SOS_CITIZEN_SCHEDULED_VISIT_MANAGE)
    },
    {
        id: "citizen-scheduled-visit-form",
        path: "citizen-scheduled-visit/form/:id?",
        Component: CitizenScheduledVisitForm,
        loader: requirePermission(PermissionEnum.SOS_CITIZEN_SCHEDULED_VISIT_MANAGE)
    },
    {
        id: "dashboard-sos",
        path: "dashboard-sos",
        Component: DashboardSos,
        loader: requirePermission(PermissionEnum.SOS_DASHBOARD)
    },
];

export default RouterSos;
